export type MfaMethod = 'TOTP' | 'EMAIL' | 'BACKUP_CODE';

export type AuthTokens = {
  accessToken: string;
  refreshToken: string;
  space: string;
};

/**
 * The login no longer reports which factor is configured: a user has exactly one primary
 * method (TOTP or email) and the step-up screen is the same for both.
 */
export type MfaRequiredResponse = {
  mfaRequired: true;
  mfaSession: string;
  /**
   * False means the account has no method of its own and the backend just emailed a one-off
   * code to let it in. That state has no backup codes, so the recovery link must stay hidden.
   */
  mfaConfigured: boolean;
};

export type LoginResponse = AuthTokens | MfaRequiredResponse;

export type GoogleNonceResponse = {
  nonce: string;
};

export type MfaSetupResponse = {
  otpauthUri: string;
  qrDataUrl: string;
};

export type BackupCodesResponse = {
  backupCodes: string[];
};

export type MfaStatusResponse = {
  enabled: boolean;
  methods: Array<Extract<MfaMethod, 'TOTP' | 'EMAIL'>>;
  backupCodesRemaining: number;
};

export type MfaError = {
  reference?: string;
  message?: string;
};

export const isMfaRequiredResponse = (response: LoginResponse): response is MfaRequiredResponse =>
  'mfaRequired' in response && response.mfaRequired;
